<script setup lang="ts">
// hooks
import { useStrapiHeader } from '@api/strapi/header/strapi-header.hook'
// components
import HeaderRoot from '@Widgets/Headers/HeaderRoot.vue'

defineOptions({
  name: 'HeaderLegacy',
})

const { refHeader } = await useStrapiHeader()
</script>

<template>
  <HeaderRoot
    v-if="refHeader"
    :data="refHeader"
  />
</template>
